// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animate-in-to-left {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes animate-out-to-left {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-100%);
    }
}

@keyframes animate-in-to-right {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes animate-out-to-right {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(100%);
    }
}

.enter-to-left {
    animation: animate-in-to-left 600ms;
    height: 100%;
    width: 100%;
}

.exit-to-left {
    animation: animate-out-to-left 600ms;
    width: 100%;
    height: 100%;
}

.exit-to-left .carousel-caption {
    opacity: 0;
    width: 100%;
    height: 100%;
}

.enter-to-right {
    animation: animate-in-to-right 600ms;
    height: 100%;
    width: 100%;
}

.exit-to-right {
    animation: animate-out-to-right 600ms;
    width: 100%;
    height: 100%;
}

.exit-to-right .carousel-caption {
    opacity: 0;
    width: 100%;
    height: 100%;
}

.carousel-slide {
    position: relative;
    text-align: center;
    margin: 0 auto;
    display: none;
    min-width: 100%;
    min-height: 100%;
    text-align: center;
    justify-self: center;
}


.carousel-slide.swipe {
    user-select: none;
    pointer-events: none;
    width: 100%;
    height: 100%;
}


.carousel-slide.active-slide {
    display: block;
    width: 100%;
    height: 100%;
    background-color: #f3f3f3;
}


.carousel-slide.active-slide.next-active-slide {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}


.carousel-slide.active-slide img {
    width: 100%;
    height: 100%;
    display: block;
}


.carousel-slide.active-slide .carousel-caption {
    position: absolute;
    right: 35px;
    bottom: 20px;
    left: 35px;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #000;

}


.carousel-slide.active-slide .carousel-caption .carousel-caption-title, 

.carousel-slide.active-slide .carousel-caption .carousel-caption-subtitle {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}


 .carousel-slide.active-slide .carousel-caption .carousel-caption-title {
    margin: 0 0 5px;
}


.carousel-slide.active-slide .carousel-caption .carousel-caption-subtitle {
    margin: 0;
}


.carousel-control {
    position: absolute;
    top: 50%;
    left: 0;
    width: 65px;
    font-size: 20px;
    color: #000;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
    background-color: rgba(0, 0, 0, 0);
    filter: alpha(opacity=50);
    z-index: 1;
}


 .carousel-control .left-triangle {
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-left: 35px solid #000;
    border-bottom: 30px solid transparent;
    position: absolute;
    left: -1px;
    cursor: initial;
    transform: translateY(-50%);
}


.carousel-control .right-triangle {
    width: 0;
    height: 0;
    border-top: 30px solid transparent;
    border-right: 35px solid #000;
    border-bottom: 30px solid transparent;
    position: absolute;
    right: -1px;
    cursor: initial;
    transform: translateY(-50%);
}


.carousel-control.carousel-left-arrow button {
    position: absolute;
    left: -1px;
    transform: translateY(-50%);
}


.carousel-control.carousel-right-arrow {
    right: 0;
    left: auto;
}


.carousel-control.carousel-right-arrow button {
    position: absolute;
    right: -1px;
    transform: translateY(-50%);
}


.carousel-control button {
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
    height: 30px;
}


.carousel-control button.padding-left-15 {
    padding-left: 15px;
}


.carousel-control button.padding-right-15 {
    padding-right: 15px;
}


 .carousel-control button svg {
    width: 15px;
    opacity: 0.5;
    cursor: pointer;
}


.carousel-control button svg:hover {
    opacity: 0.9;
}


.carousel-control button i {
    opacity: 0.5;
    cursor: pointer;
    color: #000;
    font-size: 28px;
}


.carousel-control button i:hover {
    opacity: 1;
}


.carousel-indicators {
    position: absolute;
    bottom: 10px;
    z-index: 15;
    padding-left: 0;
    list-style: none;
    margin-top: 0;
    margin-bottom: 10px;
}


 .carousel-indicators.position-left {
    left: 35px;
}


.carousel-indicators.position-right {
    right: 35px;
}


 .carousel-indicators.position-center {
    left: 50%;
    transform: translateX(-50%);
}


 .carousel-indicators li {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 1px;
    text-indent: -999px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #000;
    border-radius: 10px;
    opacity: 1;
}


 .carousel-indicators li:hover {
    background-color: #000;
    opacity: 0.7;
}


 .carousel-indicators li.active {
    width: 10px;
    height: 10px;
    margin: 0;
    background-color: #000;
    cursor: initial;
    opacity: 1;
}

@media (min-width: 768px) {
    
     .carousel-slide.active-slide .carousel-caption {
        padding-bottom: 30px;
        left: 65px;
        right: 65px;
    }

    
     .carousel-control .left-triangle {
        border-top: 50px solid transparent;
        border-left: 65px solid #000;
        border-bottom: 50px solid transparent;
    }

    
     .carousel-control .right-triangle {
        border-top: 50px solid transparent;
        border-right: 65px solid #000;
        border-bottom: 50px solid transparent;
    }

    
    .carousel-control button {
        height: 50px;
    }

    
    .carousel-control button svg {
        width: 25px;
    }

    
     .carousel-control button i {
        font-size: 50px;
    }

    
    .carousel-indicators.position-left {
        left: 65px;
    }

    
     .carousel-indicators.position-right {
        right: 65px;
    }

    
     .carousel-indicators li {
        width: 10px;
        height: 10px;
    }

    
     .carousel-indicators li.active {
        width: 12px;
        height: 12px;
    }
}

@media (min-width: 992px) {
    
     .carousel-slide.exit-to-left .carousel-caption, 
     .carousel-slide.exit-to-right .carousel-caption {
        opacity: 1;
    }
}

.active {
    filter: brightness(53%);
}`, "",{"version":3,"sources":["webpack://./src/components/Carousel/style/PhotoSliderCss.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;;AAGA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;AACV;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;;AAEf;;;AAGA;;;IAGI,yCAAyC;AAC7C;;;CAGC;IACG,eAAe;AACnB;;;AAGA;IACI,SAAS;AACb;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,kCAAkC;IAClC,yBAAyB;IACzB,UAAU;AACd;;;CAGC;IACG,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,4BAA4B;IAC5B,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,2BAA2B;AAC/B;;;AAGA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,2BAA2B;AAC/B;;;AAGA;IACI,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,2BAA2B;AAC/B;;;AAGA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,UAAU;IACV,YAAY;AAChB;;;AAGA;IACI,kBAAkB;AACtB;;;AAGA;IACI,mBAAmB;AACvB;;;CAGC;IACG,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,UAAU;AACd;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;;CAGC;IACG,UAAU;AACd;;;AAGA;IACI,WAAW;AACf;;;CAGC;IACG,SAAS;IACT,2BAA2B;AAC/B;;;CAGC;IACG,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;AACd;;;CAGC;IACG,sBAAsB;IACtB,YAAY;AAChB;;;CAGC;IACG,WAAW;IACX,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;;KAEK;QACG,oBAAoB;QACpB,UAAU;QACV,WAAW;IACf;;;KAGC;QACG,kCAAkC;QAClC,4BAA4B;QAC5B,qCAAqC;IACzC;;;KAGC;QACG,kCAAkC;QAClC,6BAA6B;QAC7B,qCAAqC;IACzC;;;IAGA;QACI,YAAY;IAChB;;;IAGA;QACI,WAAW;IACf;;;KAGC;QACG,eAAe;IACnB;;;IAGA;QACI,UAAU;IACd;;;KAGC;QACG,WAAW;IACf;;;KAGC;QACG,WAAW;QACX,YAAY;IAChB;;;KAGC;QACG,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;;KAEK;;QAEG,UAAU;IACd;AACJ;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["@keyframes animate-in-to-left {\r\n    0% {\r\n        transform: translateX(100%);\r\n    }\r\n    100% {\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n@keyframes animate-out-to-left {\r\n    0% {\r\n        transform: translateX(0);\r\n    }\r\n    100% {\r\n        transform: translateX(-100%);\r\n    }\r\n}\r\n\r\n@keyframes animate-in-to-right {\r\n    0% {\r\n        transform: translateX(-100%);\r\n    }\r\n    100% {\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n@keyframes animate-out-to-right {\r\n    0% {\r\n        transform: translateX(0);\r\n    }\r\n    100% {\r\n        transform: translateX(100%);\r\n    }\r\n}\r\n\r\n.enter-to-left {\r\n    animation: animate-in-to-left 600ms;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.exit-to-left {\r\n    animation: animate-out-to-left 600ms;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.exit-to-left .carousel-caption {\r\n    opacity: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.enter-to-right {\r\n    animation: animate-in-to-right 600ms;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.exit-to-right {\r\n    animation: animate-out-to-right 600ms;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.exit-to-right .carousel-caption {\r\n    opacity: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.carousel-slide {\r\n    position: relative;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    display: none;\r\n    min-width: 100%;\r\n    min-height: 100%;\r\n    text-align: center;\r\n    justify-self: center;\r\n}\r\n\r\n\r\n.carousel-slide.swipe {\r\n    user-select: none;\r\n    pointer-events: none;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n\r\n.carousel-slide.active-slide {\r\n    display: block;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #f3f3f3;\r\n}\r\n\r\n\r\n.carousel-slide.active-slide.next-active-slide {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    left: 0;\r\n    top: 0;\r\n}\r\n\r\n\r\n.carousel-slide.active-slide img {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n\r\n\r\n.carousel-slide.active-slide .carousel-caption {\r\n    position: absolute;\r\n    right: 35px;\r\n    bottom: 20px;\r\n    left: 35px;\r\n    z-index: 10;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    color: #000;\r\n\r\n}\r\n\r\n\r\n.carousel-slide.active-slide .carousel-caption .carousel-caption-title, \r\n\r\n.carousel-slide.active-slide .carousel-caption .carousel-caption-subtitle {\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n\r\n .carousel-slide.active-slide .carousel-caption .carousel-caption-title {\r\n    margin: 0 0 5px;\r\n}\r\n\r\n\r\n.carousel-slide.active-slide .carousel-caption .carousel-caption-subtitle {\r\n    margin: 0;\r\n}\r\n\r\n\r\n.carousel-control {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    width: 65px;\r\n    font-size: 20px;\r\n    color: #000;\r\n    text-align: center;\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\r\n    background-color: rgba(0, 0, 0, 0);\r\n    filter: alpha(opacity=50);\r\n    z-index: 1;\r\n}\r\n\r\n\r\n .carousel-control .left-triangle {\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 30px solid transparent;\r\n    border-left: 35px solid #000;\r\n    border-bottom: 30px solid transparent;\r\n    position: absolute;\r\n    left: -1px;\r\n    cursor: initial;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n\r\n.carousel-control .right-triangle {\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 30px solid transparent;\r\n    border-right: 35px solid #000;\r\n    border-bottom: 30px solid transparent;\r\n    position: absolute;\r\n    right: -1px;\r\n    cursor: initial;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n\r\n.carousel-control.carousel-left-arrow button {\r\n    position: absolute;\r\n    left: -1px;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n\r\n.carousel-control.carousel-right-arrow {\r\n    right: 0;\r\n    left: auto;\r\n}\r\n\r\n\r\n.carousel-control.carousel-right-arrow button {\r\n    position: absolute;\r\n    right: -1px;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n\r\n.carousel-control button {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    padding: 0;\r\n    height: 30px;\r\n}\r\n\r\n\r\n.carousel-control button.padding-left-15 {\r\n    padding-left: 15px;\r\n}\r\n\r\n\r\n.carousel-control button.padding-right-15 {\r\n    padding-right: 15px;\r\n}\r\n\r\n\r\n .carousel-control button svg {\r\n    width: 15px;\r\n    opacity: 0.5;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.carousel-control button svg:hover {\r\n    opacity: 0.9;\r\n}\r\n\r\n\r\n.carousel-control button i {\r\n    opacity: 0.5;\r\n    cursor: pointer;\r\n    color: #000;\r\n    font-size: 28px;\r\n}\r\n\r\n\r\n.carousel-control button i:hover {\r\n    opacity: 1;\r\n}\r\n\r\n\r\n.carousel-indicators {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    z-index: 15;\r\n    padding-left: 0;\r\n    list-style: none;\r\n    margin-top: 0;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n\r\n .carousel-indicators.position-left {\r\n    left: 35px;\r\n}\r\n\r\n\r\n.carousel-indicators.position-right {\r\n    right: 35px;\r\n}\r\n\r\n\r\n .carousel-indicators.position-center {\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n\r\n .carousel-indicators li {\r\n    display: inline-block;\r\n    width: 8px;\r\n    height: 8px;\r\n    margin: 1px;\r\n    text-indent: -999px;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n    border: 1px solid #000;\r\n    border-radius: 10px;\r\n    opacity: 1;\r\n}\r\n\r\n\r\n .carousel-indicators li:hover {\r\n    background-color: #000;\r\n    opacity: 0.7;\r\n}\r\n\r\n\r\n .carousel-indicators li.active {\r\n    width: 10px;\r\n    height: 10px;\r\n    margin: 0;\r\n    background-color: #000;\r\n    cursor: initial;\r\n    opacity: 1;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    \r\n     .carousel-slide.active-slide .carousel-caption {\r\n        padding-bottom: 30px;\r\n        left: 65px;\r\n        right: 65px;\r\n    }\r\n\r\n    \r\n     .carousel-control .left-triangle {\r\n        border-top: 50px solid transparent;\r\n        border-left: 65px solid #000;\r\n        border-bottom: 50px solid transparent;\r\n    }\r\n\r\n    \r\n     .carousel-control .right-triangle {\r\n        border-top: 50px solid transparent;\r\n        border-right: 65px solid #000;\r\n        border-bottom: 50px solid transparent;\r\n    }\r\n\r\n    \r\n    .carousel-control button {\r\n        height: 50px;\r\n    }\r\n\r\n    \r\n    .carousel-control button svg {\r\n        width: 25px;\r\n    }\r\n\r\n    \r\n     .carousel-control button i {\r\n        font-size: 50px;\r\n    }\r\n\r\n    \r\n    .carousel-indicators.position-left {\r\n        left: 65px;\r\n    }\r\n\r\n    \r\n     .carousel-indicators.position-right {\r\n        right: 65px;\r\n    }\r\n\r\n    \r\n     .carousel-indicators li {\r\n        width: 10px;\r\n        height: 10px;\r\n    }\r\n\r\n    \r\n     .carousel-indicators li.active {\r\n        width: 12px;\r\n        height: 12px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    \r\n     .carousel-slide.exit-to-left .carousel-caption, \r\n     .carousel-slide.exit-to-right .carousel-caption {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.active {\r\n    filter: brightness(53%);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
